import {Loader} from "@googlemaps/js-api-loader"

export default class Map {
    constructor(id) {
        const loader = new Loader({
            apiKey: 'AIzaSyCRJ2D7Rtx2nwy7U-tluSqj7O0XxKld0ZI',
            version: 'weekly',
        });

        this.container = document.getElementById(id);

        loader.load().then(() => {
            this.map = new google.maps.Map(this.container, {
                center: {lat: 52.255746544771924, lng: 5.683763774202554},
                zoom: 9,
                disableDefaultUI: true,
                zoomControl: true
            });
        });

        this.markers = [];
    }

    addMarkers(positions) {
        const bounds = new google.maps.LatLngBounds();
        positions.forEach((position) => {
            this.addMarker(position)
            bounds.extend(position);
        });
        this.map.fitBounds(bounds);
    }

    // addMarkers(addresses) {
    //     const promises = [];
    //
    //     addresses.forEach((address) => {
    //         promises.push(this.getPosition(address));
    //     });
    //
    //     // if(addresses.length > 0) {
    //     //     this.showMap();
    //     // }
    //
    //     Promise.all(promises).then(positions => {
    //         const bounds = new google.maps.LatLngBounds();
    //
    //         positions.forEach(position => {
    //             this.addMarker(position)
    //             bounds.extend(position);
    //         });
    //
    //         this.map.fitBounds(bounds);
    //     });
    // }

    addMarker(position) {
        const marker = new google.maps.Marker({
            map: this.map,
            position
        });

        this.markers.push(marker);
    }

    setMapOnAll(map) {
        for (var i = 0; i < this.markers.length; i++) {
            this.markers[i].setMap(map);
        }
    }

    clearMarkers() {
        this.setMapOnAll(null);
    }

    showMarkers() {
        this.setMapOnAll(map);
    }

    deleteMarkers() {
        this.clearMarkers();
        this.markers = [];
    }

    hasMarkers() {
        return this.markers.length > 0
    }

    showMap() {
        this.container.classList.remove('d-none');
    }

    hideMap() {
        this.container.classList.add('d-none');
    }

    getPosition(address) {
        const geocoder = new google.maps.Geocoder();
        return new Promise((resolve, reject) => {
            geocoder.geocode({
                address
            }, (results, status) => {
                if (status === google.maps.GeocoderStatus.OK) {
                    const position = new google.maps.LatLng({
                        lat: results[0].geometry.location.lat(),
                        lng: results[0].geometry.location.lng()
                    });

                    resolve(position);
                } else {
                    reject(new Error(status));
                }
            });
        });
    }
}
